import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { BlogListingPage } from './pages/BlogListingPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { initializeGA, pageview } from './utils/googleAnalytics';
export function App() {
  useEffect(() => {
    // Initialize Google Analytics 4
    initializeGA();
    // Track initial page view
    pageview(window.location.pathname);
  }, []);
  return <Router data-id="element-0" data-mp="31agq8u4rwpm3">
      <div className="w-full min-h-screen bg-gray-50" data-id="element-1" data-mp="31ayqe1uk3nza">
        <Helmet data-id="element-2" data-mp="31cjn9y4cfj0b">
          <title data-id="element-3" data-mp="2wka18t6cn33b">
            I75 Audio & Video, LLC | Southwest Florida's Premier AV Solutions
          </title>
          <meta name="description" content="Southwest Florida's premier provider of audio, video, and smart technology solutions for homes and businesses. Home theater, commercial audio, camera systems, WiFi networks, and more." data-id="element-4" data-mp="28tw4ipctkg2e" />
          <meta name="keywords" content="home theater, audio video, smart home, commercial audio, camera systems, WiFi networks, Southwest Florida, Cape Coral" data-id="element-5" data-mp="3ii4su47vuwpm" />
          <meta property="og:title" content="I75 Audio & Video, LLC | Southwest Florida's Premier AV Solutions" data-id="element-6" data-mp="3recbnd7qcbci" />
          <meta property="og:description" content="Custom installations by experienced pros — Home Theater, Camera Systems, Whole Home Audio & Commercial AV." data-id="element-7" data-mp="2zlv8iz6e19x6" />
          <meta property="og:type" content="website" data-id="element-8" data-mp="38li8dgjgy7o4" />
          <meta property="og:url" content="https://i75av.com" data-id="element-9" data-mp="38num1hi71vvd" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/v7yfSfpEBAhNGcxDkT5ZNW/i75_transparent_PNG.png" data-id="element-10" data-mp="3dlnru9fl4nv4" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-11" data-mp="stuexv3nyxa2" />
          <link rel="canonical" href="https://i75av.com" data-id="element-12" data-mp="36hwf6uoms18" />
        </Helmet>

        <Navigation data-id="element-13" data-mp="34ndfy2z19zs" />

        <Routes data-id="element-14" data-mp="3uct4hmy40t22">
          <Route path="/" element={<HomePage data-id="element-16" data-mp="3ubrhql7qei4i" />} data-id="element-15" data-mp="3udawu8hnin4p" />
          <Route path="/blog" element={<BlogListingPage data-id="element-18" data-mp="d4nwrk0ubq3z" />} data-id="element-17" data-mp="3ucjcjtti8btq" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-20" data-mp="d3wdn8ofjkul" />} data-id="element-19" data-mp="d4xpvgh6mddw" />
        </Routes>
      </div>
    </Router>;
}